import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class WorkshopStepsTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'WorkshopStepsTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      localeId: null,
      title: '',
      workshopStepId: null,
    }
  }
}
const servicePath = 'workshop-steps-translations'
const servicePlugin = makeServicePlugin({
  Model: WorkshopStepsTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
